import React from "react";
import CardMessage from "./../Cards/CardMessage";
import { MDBBtn, MDBRow } from "mdbreact";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Spinner from "../spinner";
export default function Messages({ messages, loading, hasNextPage, nextPage }) {
  const { userId, name, username, postId, socket } = useSelector(state => ({
    ...state.User,
    ...state.Post,
    ...state.Socket
  }));
  const options = {
    timeZone: "UTC",
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric"
  };
  const messageRef = React.useRef();
  const Message = ({ messages }) => {
    return messages.map(message => (
      <div key={message._id} className="d-flex flex-column w-100 ">
        <CardMessage userId={userId} options={options} {...message} />
      </div>
    ));
  };
  React.useEffect(() => {
    scrollBottom();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages]);

  const scrollBottom = () =>
    (messageRef.current.scrollTop = messageRef.current.scrollHeight);
  return (
    <>
      <div className="messages scroll " ref={messageRef}>
        <div className="inner">
          {messages && (
            <>
              <Message messages={messages} />{" "}
              <MDBRow>
                {" "}
                {!loading && hasNextPage && (
                  <MDBBtn
                    className="btn-view-more"
                    onClick={() => nextPage(messages[messages.length - 1]._id)}
                  >
                    {" "}
                    Ver más{" "}
                  </MDBBtn>
                )}
                {loading && (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "center"
                    }}
                  >
                    <Spinner />{" "}
                  </div>
                )}
              </MDBRow>
            </>
          )}
        </div>
      </div>
    </>
  );
}
